import { render } from "./SuperAdminListCompany.vue?vue&type=template&id=0f0555f8&scoped=true"
import script from "./SuperAdminListCompany.vue?vue&type=script&lang=js"
export * from "./SuperAdminListCompany.vue?vue&type=script&lang=js"

import "./SuperAdminListCompany.vue?vue&type=style&index=0&id=0f0555f8&scoped=true&lang=css"
import "./SuperAdminListCompany.vue?vue&type=style&index=1&id=0f0555f8&lang=css"
import "./SuperAdminListCompany.vue?vue&type=style&index=2&id=0f0555f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0555f8"]])

export default __exports__